/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/inbound/saas.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- APP
----------------------------------*/

import SaaSInboundLanding from '@/client/components/marketing/inbound/SaaSInboundLanding';

/*----------------------------------
- CONTROLEUR
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/inbound/saas', { ...({
  static: {
    refresh: '1h',
    urls: ['/inbound/saas']
  }
}), ...{ filepath: "/app/client/pages/inbound/saas.tsx", sourceLocation: { line: 12, column: 1 }, id: "inbound_saas" } }, null, () => <SaaSInboundLanding />);
};
